import React from 'react';
import { Link } from 'react-router-dom';
import { ActivityIcon, ArrowLeftIcon, CalendarClockIcon } from 'lucide-react';
import { loanOfficer, processor } from '../../data/team';
import type { BorrowerTask } from '../../types/application';
import { subscriber } from '../../data/subscriber';
import { useTokens } from '../../hooks/useTokens';
interface TaskLayoutProps {
  task: BorrowerTask;
  heading: string;
  why: string;
  after: string;
  children: React.ReactNode;
}
export function TaskLayout({
  task,
  heading,
  why,
  after,
  children
}: TaskLayoutProps) {
  const {
    fill
  } = useTokens();
  const person = task.from === 'processor' ? processor : task.from === 'loanOfficer' ? loanOfficer : null;
  return <main className="mx-auto max-w-[620px] px-5 pb-16 pt-6 md:pt-10" data-id="element-637" data-mp="2fws32dm2tlmg">
      <Link to="/loan" className="inline-flex items-center gap-1.5 rounded-lg text-sm font-medium text-ink-500 transition-colors duration-150 hover:text-ink-900" data-id="element-638" data-mp="i5p5b4jn0a6u">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden data-id="element-639" data-mp="e29bsh2v6pyd" /> Overview
      </Link>

      <div className="mt-8 flex items-center gap-3" data-id="element-640" data-mp="2npmupnk3dotv">
        {person ? <img src={person.photo} alt="" className="h-10 w-10 rounded-full object-cover" data-id="element-641" data-mp="2sqkkal7fll5e" /> : <span className="grid h-10 w-10 place-items-center rounded-full bg-pulse-600 text-white" data-id="element-642" data-mp="2erkx7hzkhebc">
            <ActivityIcon className="h-5 w-5" aria-hidden data-id="element-643" data-mp="2it666s8zd8g9" />
          </span>}
        <div className="text-sm" data-id="element-644" data-mp="36hfmxfrc760j">
          <p className="font-medium text-ink-900" data-id="element-645" data-mp="36i8v8l5y23ks">{person ? person.name : subscriber.companyShortName}</p>
          <p className="text-ink-500" data-id="element-646" data-mp="3bg0nxheextq1">{person ? person.title : 'Your loan team'}</p>
        </div>
        {task.due && <span className="ml-auto inline-flex items-center gap-1.5 rounded-full bg-caution-50 px-3 py-1 text-xs font-medium text-caution-700" data-id="element-647" data-mp="2xnkqqx870px1">
            <CalendarClockIcon className="h-3.5 w-3.5" aria-hidden data-id="element-648" data-mp="3pfihea2nlv5q" /> Due {task.due}
          </span>}
      </div>

      <h1 className="mt-6 text-[28px] font-semibold leading-tight tracking-[-0.03em] text-ink-900 md:text-[36px]" data-id="element-649" data-mp="3u8utjkq5c9hl">{heading}</h1>
      <p className="mt-3 text-[17px] leading-relaxed text-ink-700" data-id="element-650" data-mp="7vjot4ic7jmj">{fill(task.title)}.</p>

      <dl className="mt-6 grid gap-4 border-y border-ink-200 py-5 text-sm sm:grid-cols-2" data-id="element-651" data-mp="3u6h0ovop6cz">
        <div data-id="element-652" data-mp="3v4orkvc8b7uf">
          <dt className="font-medium text-ink-900" data-id="element-653" data-mp="3v4f0t5jd0wno">Why we need it</dt>
          <dd className="mt-1 leading-relaxed text-ink-500" data-id="element-654" data-mp="3q2zc93hz480j">{why}</dd>
        </div>
        <div data-id="element-655" data-mp="3l57nujgjf413">
          <dt className="font-medium text-ink-900" data-id="element-656" data-mp="3l5z6ktp1d79y">What happens next</dt>
          <dd className="mt-1 leading-relaxed text-ink-500" data-id="element-657" data-mp="3gcmwrpp0n519">{after}</dd>
        </div>
      </dl>

      <div className="mt-8" data-id="element-658" data-mp="3cbb0507q5jjk">{children}</div>
    </main>;
}